import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  FieldWrapper,
  Label,
  RadioButton,
  Text,
  useResponsive,
} from '@common-fe/common-fe';

import { ReviewOption } from '../hooks/useReviewStepNavigation';

interface Props {
  formattedAddress: string;
  selectedOption: ReviewOption | null;
  onSelectOption: (option: ReviewOption) => void;
}

const ReviewStep: React.FC<Props> = ({ formattedAddress, selectedOption, onSelectOption }) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  return (
    <Box
      pad={isMobile ? 'spacing8' : 'spacing24'}
      round={isMobile ? 'container1Round' : 'moduleRound'}
      background="module"
    >
      <Box
        pad={isMobile ? 'spacing12' : 'spacing24'}
        background="canvas"
        round="container1Round"
        border={{ color: 'border2', size: '1px' }}
        data-testid="bad-address-review_address-section"
        margin={{ bottom: isMobile ? 'spacing8' : 'spacing24' }}
      >
        <FieldWrapper direction={isMobile ? 'column' : 'row'} align={isMobile ? 'stretch' : 'center'}>
          <Label name="currentAddress" isNarrow={!isMobile} margin={isMobile ? { bottom: 'spacing12' } : {}}>
            {t('Current address')}
          </Label>
          <Text color="textBody">{formattedAddress}</Text>
        </FieldWrapper>
      </Box>

      <Box
        pad={isMobile ? 'spacing12' : 'spacing24'}
        background="canvas"
        round="container1Round"
        border={{ color: 'border2', size: '1px' }}
      >
        <FieldWrapper direction={isMobile ? 'column' : 'row'} align="start">
          <Label
            name="addressReview"
            isNarrow={!isMobile}
            showRequireIcon
            margin={isMobile ? { bottom: 'spacing12' } : {}}
          >
            {t('Is the address listed above correct?')}
          </Label>
          <Box gap="spacing12">
            <RadioButton
              data-testid="bad-address-review_option-correct"
              name="addressReview"
              checked={selectedOption === ReviewOption.CORRECT}
              onChange={() => onSelectOption(ReviewOption.CORRECT)}
              label={(
                <Box height="24px" align="center">
                  <Text color="textBody" margin={{ vertical: 'auto' }}>
                    {t('Yes, its correct')}
                  </Text>
                </Box>
              )}
            />
            <RadioButton
              data-testid="bad-address-review_option-update"
              name="addressReview"
              checked={selectedOption === ReviewOption.NEEDS_UPDATE}
              onChange={() => onSelectOption(ReviewOption.NEEDS_UPDATE)}
              label={(
                <Box height="24px" align="center">
                  <Text color="textBody" margin={{ vertical: 'auto' }}>
                    {t('No, needs to be updated')}
                  </Text>
                </Box>
              )}
            />
          </Box>
        </FieldWrapper>
      </Box>
    </Box>
  );
};

export default ReviewStep;
